import { useSearchParams } from 'react-router-dom'

// Ember parity: ticket.dineIn is set from ?dineIn alone (routes/application.js).
// tableName (Ember: tableNotes) is only the table label and does not make a session dine-in.
export function useIsDineInScan(): boolean {
	const [searchParams] = useSearchParams()

	return searchParams.get('dineIn') === 'true'
}
